module.exports = __webpack_public_path__ + "static/media/references-nordic.28462ed9.png";